import { DisplayTypeEnum } from 'api/files';
import { GenericColors } from 'api/tenant';

export type ToastColor = GenericColors;

export interface ToastNotification {
  id: string;
  title?: string;
  subtitle?: string;
  message: string;
  displayType: DisplayTypeEnum;
  color?: ToastColor;
  createdAt: number;
}

export interface NotificationPayload {
  title?: string;
  subtitle?: string;
  message: string;
  displayType: DisplayTypeEnum;
  color?: ToastColor;
}

type ToastListener = (toast: ToastNotification) => void;

class ToasterService {
  private static instance: ToasterService;
  private listeners: Set<ToastListener> = new Set();

  private constructor() {}

  static getInstance(): ToasterService {
    if (!ToasterService.instance) {
      ToasterService.instance = new ToasterService();
    }
    return ToasterService.instance;
  }

  subscribe(listener: ToastListener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  showToast(notification: NotificationPayload): void {
    const toast: ToastNotification = {
      id: `toast-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      ...notification,
      createdAt: Date.now()
    };

    this.listeners.forEach(listener => listener(toast));
  }
}

export const toasterService = ToasterService.getInstance();
